export default function ToastSuccessMessage({ message, handleClose }) {
    return (
        <div
            className="fixed bottom-5 left-1/2 z-50 flex w-[calc(100%-2rem)] max-w-lg -translate-x-1/2 items-start gap-3 rounded-2xl bg-white p-4 shadow-[0_0_0_1px_var(--hairline)]"
            role="alert"
        >
            <div className="min-w-0 flex-1">
                <p className="font-Mulish text-sm font-semibold text-secondary">Done</p>
                {message ? (
                    <p className="mt-1 font-Mulish text-sm text-graphite">{message}</p>
                ) : null}
            </div>
            <button
                type="button"
                aria-label="Close"
                onClick={handleClose}
                className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white font-Mulish text-sm text-primary-700 shadow-[0_0_0_1px_var(--hairline)]"
            >
                ×
            </button>
        </div>
    );
}
